<template>
  <section class="introduction-container">
    <div class="title-container pic-full" :class="lang"></div>
    <p class="desc" :class="lang">{{ homeLang.introduction.desc }}</p>
    <div
      class="button-container flex-center pic-full"
      :class="mouseDown ? 'down' : 'normal'"
      @click="toUrl('open', homeLang.head[0].url)"
      @mousedown="mouseDown = true"
      @mouseup="mouseDown = false"
      @touchstart="mouseDown = true"
      @touchend="mouseDown = false"
    >
      <span>{{ homeLang.introduction.start }}</span>
      <div class="button-icon pic-full"></div>
    </div>
    <div class="outer-token-container" ref="outerTokenContainer">
      <div class="token-container" ref="tokenContainer">
        <div
          class="token-item pic-full"
          :class="parseFloat(item.percent_change_24h) > 0 ? 'rise' : 'drop'"
          v-for="item in token"
        >
          <img draggable="false" :src="item.logo" />
          <p class="price">{{ item.price_show }}</p>
          <p
            class="flow"
            :class="parseFloat(item.percent_change_24h) > 0 ? 'rise' : 'drop'"
          >
            {{ item.flow_show }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "introduction",
  props: {
    homeLang: {
      type: Object,
    },
  },
  data() {
    return {
      token: [],
      copiedToken: [],
      mouseDown: false,
    };
  },
  mounted() {
    // 自动滚动
    (function () {
      const parent = document.getElementsByClassName(
        "outer-token-container"
      )[0];
      const child1 = document.getElementsByClassName("token-container")[0];
      // const child2 = document.getElementById('child2');
      // child2.innerHTML = child1.innerHTML;
      setInterval(function () {
        if (parent.scrollLeft >= child1.scrollWidth) {
          parent.scrollLeft = 0;
        } else {
          parent.scrollLeft++;
        }
      }, 40);
    })();

    // 鼠标拖动滚动
    let dv = document.getElementsByClassName("outer-token-container")[0],
      ox;
    let nowScrollLeft = 0;

    function mousemove(e) {
      dv.scrollLeft = nowScrollLeft + ox - e.clientX;
    }

    function mouseup() {
      nowScrollLeft = dv.scrollLeft;
      dv.onmouseup = dv.onmousemove = null;
    }

    dv.onmousedown = function (e) {
      dv.onmousemove = mousemove;
      dv.onmouseup = mouseup;
      ox = e.clientX;
    };

    setTimeout(() => {
      this.getList();
    }, 500);

    // setInterval(()=>{
    //   this.getList()
    // }, 60000)

    const outerTokenContainer = this.$refs.outerTokenContainer,
      tokenContainer = this.$refs.tokenContainer;

    outerTokenContainer.addEventListener("scroll", () => {
      const rem = parseFloat(
          window.getComputedStyle(document.documentElement)["fontSize"]
        ),
        outerLeft = outerTokenContainer.scrollLeft,
        outerWidth = outerTokenContainer.clientWidth,
        innerWidth = tokenContainer.clientWidth;
      const remainRem = (innerWidth - outerWidth - outerLeft) / rem;

      if (remainRem < 4) {
        tokenContainer.style.width =
          (this.token.length + this.copiedToken.length) * 1.8 + 0.84 + "rem";
        this.token = this.token.concat(this.copiedToken);
      }
    });
  },
  methods: {
    getList() {
      // https://preserver.mytokenpocket.vip/v1/token/token_market_price
      axios
        .get("https://preserver.mytokenpocket.vip/v1/token/token_market_price")
        .then((res) => {
          const logoList = [
            "BNB",
            "BTC",
            "CAKE",
            "DOT",
            "ETH",
            "HT",
            "MATIC",
            "OKT",
            "TRX",
            "UNI",
            "TPT",
          ];
          this.token = res.data.data.filter((item) =>
            logoList.includes(item.bl_symbol)
          );
          this.token.forEach((item) => {
            item.price_show = "$" + parseFloat(item.price).toFixed(2);
            item.flow_show =
              (parseFloat(item.percent_change_24h) > 0 ? "+" : "") +
              parseFloat(item.percent_change_24h).toFixed(2) +
              "%";
            item.logo = require("../../assets/pc/introduction/" +
              item.bl_symbol +
              ".png");
          });
          this.copiedToken = this.token.concat();
          this.$refs.tokenContainer.style.width =
            this.token.length * 1.8 + 0.84 + "rem";
        });
    },
  },
};
</script>

<style lang="less">
@media screen and (min-width: 767px) {
  .introduction-container {
    .title-container {
      &.zh {
        width: 6.5rem;
        height: 0.74rem;
        background-image: url("../../assets/pc/introduction/title_zh.png");
        margin: 1.07rem auto 0;
      }
      &.en {
        width: 8.69rem;
        height: 0.74rem;
        background-image: url("../../assets/pc/introduction/title.png");
        margin: 1.03rem auto 0;
      }
    }
    .desc {
      width: 7.81rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      line-height: 0.33rem;
      margin: 0.29rem auto 0;
      &.zh {
        margin: 0.31rem auto 0;
      }
    }
    .button-container {
      width: 3.9rem;
      height: 0.9rem;
      margin: 0.34rem auto 0;
      cursor: pointer;
      &.normal {
        background-image: url("../../assets/pc/button.png");
      }
      &.down {
        background-image: url("../../assets/pc/button_down.png");
        span {
          transform: translate(0.04rem, 0.04rem);
        }
        .button-icon {
          transform: translate(0.04rem, 0.055rem);
        }
      }
      span {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #ffffff;
      }
      .button-icon {
        width: 0.27rem;
        height: 0.22rem;
        margin-left: 0.15rem;
        background-image: url("../../assets/pc/enter.png");
        transform: translateY(0.015rem);
      }
    }
    .outer-token-container {
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      width: 11.64rem;
      height: 3.2rem;
      margin-left: 0.21rem;
      margin-top: 0.37rem;
      overflow-x: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .token-container {
        height: 100%;
        width: 20.64rem;
        transform: translateX(0rem);
        .token-item {
          float: left;
          position: relative;
          margin-top: 0.39rem;
          width: 1.8rem;
          height: 2.26rem;
          cursor: pointer;
          &:first-child {
            margin-left: 0.42rem;
          }
          &::after {
            display: block;
            content: "";
            width: 2.64rem;
            height: 3.2rem;
            margin-left: -0.42rem;
            top: -0.39rem;
            position: absolute;
            z-index: -69;
          }
          &.rise {
            background-image: url("../../assets/pc/introduction/rise.png");
            &::after {
              background-image: url("../../assets/pc/introduction/rise_shadow.png");
              background-repeat: no-repeat;
              background-size: 100%;
            }
          }
          &.drop {
            background-image: url("../../assets/pc/introduction/drop.png");
            &::after {
              background-image: url("../../assets/pc/introduction/drop_shadow.png");
              background-repeat: no-repeat;
              background-size: 100%;
            }
          }
          img {
            width: 1rem;
            margin-left: 0.38rem;
            margin-top: 0.29rem;
            display: block;
            -webkit-user-drag: none;
          }
          .price {
            margin: 0.11rem auto 0.12rem;
            font-size: 0.16rem;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #333333;
            line-height: 0.22rem;
            text-align: center;
          }
          .flow {
            margin: 0 auto;
            font-size: 0.16rem;
            font-family: PingFangSC, PingFangSC-Regular;
            width: 0.98rem;
            height: 0.24rem;
            line-height: 0.24rem;
            border-radius: 0.12rem;
            text-align: center;
            &.rise {
              color: #03c288;
              background-color: rgba(87, 212, 170, 0.1);
            }
            &.drop {
              color: #ed4c56;
              background-color: rgba(229, 80, 54, 0.1);
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .introduction-container {
    .title-container {
      &.zh {
        width: 4.04rem;
        height: 1.69rem;
        background-image: url("../../assets/mobile/introduction/title_zh.png");
        margin: 0.55rem auto 0;
      }
      &.en {
        width: 5.09rem;
        height: 1.55rem;
        background-image: url("../../assets/mobile/introduction/title.png");
        margin: 0.55rem auto 0;
      }
    }

    .desc {
      width: 5.89rem;
      font-size: 0.26rem;
      font-family: PingFangSC, PingFangSC-Regular;
      text-align: center;
      color: #333333;
      line-height: 0.37rem;
      margin: 0.3rem auto 0;

      &.zh {
        margin: 0.26rem auto 0;
      }
    }

    .button-container {
      width: 3.9rem;
      height: 0.9rem;
      margin: 0.31rem auto 0;
      cursor: pointer;

      &.normal {
        background-image: url("../../assets/mobile/button.png");
      }
      &.down {
        background-image: url("../../assets/mobile/button_down.png");
        span {
          transform: translate(0.04rem, 0.04rem);
        }
        .button-icon {
          transform: translate(0.04rem, 0.055rem);
        }
      }
      span {
        font-size: 0.24rem;
        font-family: PingFangSC, PingFangSC-Regular;
        color: #ffffff;
      }

      .button-icon {
        width: 0.27rem;
        height: 0.22rem;
        margin-left: 0.15rem;
        background-image: url("../../assets/mobile/enter.png");
        transform: translateY(0.015rem);
      }
    }
    .outer-token-container {
      -moz-user-select: none; /*火狐*/
      -webkit-user-select: none; /*webkit浏览器*/
      -ms-user-select: none; /*IE10*/
      -khtml-user-select: none; /*早期浏览器*/
      user-select: none;
      width: 7.2rem;
      height: 3.2rem;
      margin: 0.05rem auto 0;
      overflow-x: auto;
      scrollbar-width: none; /* Firefox */
      -ms-overflow-style: none; /* IE 10+ */
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .token-container {
        height: 100%;
        width: 19.8rem;
        transform: translateX(0rem);
        .token-item {
          float: left;
          position: relative;
          margin-top: 0.39rem;
          width: 1.8rem;
          height: 2.26rem;
          cursor: pointer;
          &:first-child {
            //margin-left: 0.15rem;
          }
          &::after {
            display: block;
            content: "";
            width: 2.64rem;
            height: 3.2rem;
            margin-left: -0.4rem;
            top: -0.39rem;
            position: absolute;
            z-index: -69;
          }
          &.rise {
            background-image: url("../../assets/pc/introduction/rise.png");
            &::after {
              background-image: url("../../assets/pc/introduction/rise_shadow.png");
              background-repeat: no-repeat;
              background-size: 100%;
            }
          }
          &.drop {
            background-image: url("../../assets/pc/introduction/drop.png");
            &::after {
              background-image: url("../../assets/pc/introduction/drop_shadow.png");
              background-repeat: no-repeat;
              background-size: 100%;
            }
          }
          img {
            width: 1rem;
            margin-left: 0.38rem;
            margin-top: 0.29rem;
            display: block;
            -webkit-user-drag: none;
          }
          .price {
            margin: 0.11rem auto 0.12rem;
            font-size: 0.16rem;
            font-family: PingFangSC, PingFangSC-Regular;
            color: #333333;
            line-height: 0.22rem;
            text-align: center;
          }
          .flow {
            margin: 0 auto;
            font-size: 0.16rem;
            font-family: PingFangSC, PingFangSC-Regular;
            width: 0.98rem;
            height: 0.24rem;
            line-height: 0.24rem;
            border-radius: 0.12rem;
            text-align: center;
            &.rise {
              color: #03c288;
              background-color: rgba(87, 212, 170, 0.1);
            }
            &.drop {
              color: #ed4c56;
              background-color: rgba(229, 80, 54, 0.1);
            }
          }
        }
      }
    }
  }
}
</style>
